<div
  class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-neutral-4 pb-4"
>
  <!-- Navigation principale & Titre -->
  <div class="flex items-center gap-2 sm:gap-4 flex-wrap">
    <div class="flex items-center gap-1 bg-neutral-2 border border-neutral-4 rounded-lg p-0.5">
      <button
        type="button"
        mat-icon-button
        class="!w-8 !h-8 !leading-8 text-neutral-11 hover:text-neutral-12 hover:bg-neutral-3 rounded-md transition-colors"
        (click)="previous.emit()"
        matTooltip="Période précédente"
        aria-label="Période précédente"
      >
        <mat-icon class="!text-lg !w-4 !h-4 flex items-center justify-center">chevron_left</mat-icon>
      </button>

      <button
        type="button"
        (click)="today.emit()"
        class="px-2.5 py-1 text-xs font-medium text-neutral-11 hover:text-neutral-12 hover:bg-neutral-3 rounded-md transition-colors"
      >
        Aujourd'hui
      </button>

      <button
        type="button"
        mat-icon-button
        class="!w-8 !h-8 !leading-8 text-neutral-11 hover:text-neutral-12 hover:bg-neutral-3 rounded-md transition-colors"
        (click)="next.emit()"
        matTooltip="Période suivante"
        aria-label="Période suivante"
      >
        <mat-icon class="!text-lg !w-4 !h-4 flex items-center justify-center">chevron_right</mat-icon>
      </button>
    </div>

    <h2 class="text-lg sm:text-xl font-semibold text-neutral-12 tracking-tight m-0 select-none">
      {{ title() }}
    </h2>
  </div>

  <!-- Bascule des vues & Actions export -->
  <div class="flex items-center gap-2.5 self-end sm:self-auto">
    <!-- Sélecteur de vue (Select) -->
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="aura-calendar-view-select w-36">
      <mat-select
        [value]="view()"
        (selectionChange)="viewChange.emit($event.value)"
        aria-label="Mode d'affichage de l'agenda"
      >
        <mat-select-trigger>
          <span class="inline-flex items-center gap-1.5 font-medium text-xs text-neutral-12">
            @if (view() === 'month') {
              <mat-icon class="!text-sm !w-3.5 !h-3.5 text-primary-11">calendar_view_month</mat-icon>
              <span>Mois</span>
            } @else if (view() === 'week') {
              <mat-icon class="!text-sm !w-3.5 !h-3.5 text-primary-11">calendar_view_week</mat-icon>
              <span>Semaine</span>
            } @else {
              <mat-icon class="!text-sm !w-3.5 !h-3.5 text-primary-11">view_list</mat-icon>
              <span>Liste</span>
            }
          </span>
        </mat-select-trigger>

        <mat-option value="month" #optMonth>
          <div class="flex items-center gap-2">
            <mat-icon
              class="!text-base !w-4 !h-4"
              [class]="optMonth.selected ? 'text-white' : 'text-primary-11'"
              >calendar_view_month</mat-icon
            >
            <span [class]="optMonth.selected ? 'text-white' : 'text-neutral-12'">Mois</span>
          </div>
        </mat-option>
        <mat-option value="week" #optWeek>
          <div class="flex items-center gap-2">
            <mat-icon
              class="!text-base !w-4 !h-4"
              [class]="optWeek.selected ? 'text-white' : 'text-primary-11'"
              >calendar_view_week</mat-icon
            >
            <span [class]="optWeek.selected ? 'text-white' : 'text-neutral-12'">Semaine</span>
          </div>
        </mat-option>
        <mat-option value="list" #optList>
          <div class="flex items-center gap-2">
            <mat-icon
              class="!text-base !w-4 !h-4"
              [class]="optList.selected ? 'text-white' : 'text-primary-11'"
              >view_list</mat-icon
            >
            <span [class]="optList.selected ? 'text-white' : 'text-neutral-12'">Liste</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Sélecteur d'agendas / Calques superposables (Select multiple) -->
    @if (sources().length > 0) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="aura-calendar-view-select w-44">
        <mat-select
          multiple
          [value]="selectedSourceIds()"
          (selectionChange)="onSourcesSelectionChange($event.value)"
          aria-label="Agendas affichés"
        >
          <mat-select-trigger>
            <span class="inline-flex items-center gap-1.5 font-medium text-xs text-neutral-12 truncate">
              <mat-icon class="!text-sm !w-3.5 !h-3.5 text-primary-11 shrink-0">layers</mat-icon>
              <span>Agendas ({{ selectedSourceIds().length }}/{{ sources().length }})</span>
            </span>
          </mat-select-trigger>

          @for (source of sources(); track source.id) {
            <mat-option [value]="source.id" #optSource>
              <div class="flex items-center gap-2">
                <span
                  class="w-2.5 h-2.5 rounded-full shrink-0"
                  [class]="getSourceDotClass(source.category)"
                ></span>
                <span>{{ source.name }}</span>
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <!-- Bouton Engrenage & Menu Paramètres / Export -->
    <button
      type="button"
      mat-icon-button
      [matMenuTriggerFor]="gearMenu"
      class="!w-9 !h-9 text-neutral-11 hover:text-neutral-12 hover:bg-neutral-3 rounded-lg border border-neutral-4 transition-colors cursor-pointer"
      matTooltip="Options et paramètres de l'agenda"
      aria-label="Options et paramètres de l'agenda"
    >
      <mat-icon class="!text-lg !w-5 !h-5 flex items-center justify-center">settings</mat-icon>
    </button>

    <mat-menu #gearMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="openSettings.emit()">
        <mat-icon class="!text-base !w-4 !h-4 text-neutral-11">tune</mat-icon>
        <span class="text-xs">Paramètres</span>
      </button>
      <button mat-menu-item (click)="onExportICal()" [disabled]="events().length === 0">
        <mat-icon class="!text-base !w-4 !h-4 text-neutral-11">file_download</mat-icon>
        <span class="text-xs">Exporter (.ics)</span>
      </button>
    </mat-menu>
  </div>
</div>
